import React, { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { PATH_HOME } from '@jwp/ott-common/src/paths';


import styles from './AuthLayout.module.scss';

type Props = {
  children: ReactNode;
  title: string;
  subtitle?: string;
};


function BrandLogo({ appConfig, siteName, className }: Readonly<{ appConfig: any; siteName: string | undefined; className?: string }>) {
  return (
    <div className={className}>
      {appConfig?.branding?.logo_url ? (
        <img src={appConfig.branding.logo_url} alt={siteName} className={styles.brandLogoImage} />
      ) : (
        <div className={styles.brandLogo} />
      )}
    </div>
  );
}


const AuthLayout = ({ children, title, subtitle }: Props) => {
  const { appConfig, config: { siteName } } = useConfigStore((state) => state);

  return (
    <div className={styles.authPage}>
      <div className={styles.videoLayer}>
        <video
          autoPlay
          muted
          loop
          playsInline
          className={styles.videoBackground}
          src="/videos/signin-background.mp4"
        />
      </div>
      <main className={styles.main}>
        <Link to={PATH_HOME}>
          <BrandLogo appConfig={appConfig} siteName={siteName} className={styles.brand} />
        </Link>

        <div className={styles.card}>
          <h2 className={styles.cardTitle}>{title}</h2>
          {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
          <div className={styles.cardContent}>
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
